import {
  AD_TYPES,
  AD_MEDIATION_TYPES,
  AD_STATUSES,
  STORY_TYPES,
  PLATFORMS,
} from 'app/utils/constants';
import { isEqualAppVersion } from 'app/utils/device';

import uuid from 'uuid';

import { fetchStoryAdFull } from 'app/redux/common/actions';

const {
  // mopub
  IOS_MOPUB_WAITFREE_REWARD_UNIT_ID,
  IOS_MOPUB_CHEER_REWARD_UNIT_ID,
  IOS_MOPUB_STANDARD_INTERSTITIAL_UNIT_ID,
  IOS_MOPUB_ORIGINAL_INTERSTITIAL_UNIT_ID,
  AOS_MOPUB_WAITFREE_REWARD_UNIT_ID,
  AOS_MOPUB_CHEER_REWARD_UNIT_ID,
  AOS_MOPUB_STANDARD_INTERSTITIAL_UNIT_ID,
  AOS_MOPUB_ORIGINAL_INTERSTITIAL_UNIT_ID,
  IOS_MOPUB_STANDARD_INTERSTITIAL_BACKFILL_UNIT_ID,
  IOS_MOPUB_ORIGINAL_INTERSTITIAL_BACKFILL_UNIT_ID,
  AOS_MOPUB_STANDARD_INTERSTITIAL_BACKFILL_UNIT_ID,
  AOS_MOPUB_ORIGINAL_INTERSTITIAL_BACKFILL_UNIT_ID,
  // adx
  AOS_ADX_REWARD_UNIT_ID,
  AOS_ADX_INTERSTITIAL_UNIT_ID,
  AOS_ADX_AB_INTERSTITIAL_UNIT_ID,
  IOS_ADX_REWARD_UNIT_ID,
  IOS_ADX_INTERSTITIAL_UNIT_ID,
  IOS_ADX_AB_INTERSTITIAL_UNIT_ID,
} = process.env;

const getAdType = (unitId) => {
  switch (unitId) {
    case AD_TYPES.STORY_AD_FULL:
      return AD_TYPES.STORY_AD_FULL;

    case IOS_MOPUB_WAITFREE_REWARD_UNIT_ID:
    case AOS_MOPUB_WAITFREE_REWARD_UNIT_ID:
    case IOS_ADX_REWARD_UNIT_ID:
    case AOS_ADX_REWARD_UNIT_ID:
      return AD_TYPES.REWARD;

    case IOS_MOPUB_CHEER_REWARD_UNIT_ID:
    case AOS_MOPUB_CHEER_REWARD_UNIT_ID:
      return AD_TYPES.CHEER_REWARD;

    case IOS_MOPUB_STANDARD_INTERSTITIAL_UNIT_ID:
    case IOS_MOPUB_ORIGINAL_INTERSTITIAL_UNIT_ID:
    case AOS_MOPUB_STANDARD_INTERSTITIAL_UNIT_ID:
    case AOS_MOPUB_ORIGINAL_INTERSTITIAL_UNIT_ID:
    case IOS_ADX_INTERSTITIAL_UNIT_ID:
    case IOS_ADX_AB_INTERSTITIAL_UNIT_ID:
    case AOS_ADX_INTERSTITIAL_UNIT_ID:
    case AOS_ADX_AB_INTERSTITIAL_UNIT_ID:
      return AD_TYPES.INTERSTITIAL;

    case IOS_MOPUB_STANDARD_INTERSTITIAL_BACKFILL_UNIT_ID:
    case IOS_MOPUB_ORIGINAL_INTERSTITIAL_BACKFILL_UNIT_ID:
    case AOS_MOPUB_STANDARD_INTERSTITIAL_BACKFILL_UNIT_ID:
    case AOS_MOPUB_ORIGINAL_INTERSTITIAL_BACKFILL_UNIT_ID:
      return AD_TYPES.INTERSTITIAL_BACKFILL;

    default:
      return null;
  }
};

const getAppAdType = (unitId) => {
  switch (unitId) {
    case AD_TYPES.STORY_AD_FULL:
      return AD_TYPES.STORY_AD_FULL;

    case IOS_MOPUB_WAITFREE_REWARD_UNIT_ID:
    case IOS_MOPUB_CHEER_REWARD_UNIT_ID:
    case AOS_MOPUB_WAITFREE_REWARD_UNIT_ID:
    case AOS_MOPUB_CHEER_REWARD_UNIT_ID:
    case IOS_ADX_REWARD_UNIT_ID:
    case AOS_ADX_REWARD_UNIT_ID:
      return 'reward';

    case IOS_MOPUB_STANDARD_INTERSTITIAL_UNIT_ID:
    case IOS_MOPUB_ORIGINAL_INTERSTITIAL_UNIT_ID:
    case AOS_MOPUB_STANDARD_INTERSTITIAL_UNIT_ID:
    case AOS_MOPUB_ORIGINAL_INTERSTITIAL_UNIT_ID:
    case IOS_MOPUB_STANDARD_INTERSTITIAL_BACKFILL_UNIT_ID:
    case IOS_MOPUB_ORIGINAL_INTERSTITIAL_BACKFILL_UNIT_ID:
    case AOS_MOPUB_STANDARD_INTERSTITIAL_BACKFILL_UNIT_ID:
    case AOS_MOPUB_ORIGINAL_INTERSTITIAL_BACKFILL_UNIT_ID:
    case IOS_ADX_INTERSTITIAL_UNIT_ID:
    case IOS_ADX_AB_INTERSTITIAL_UNIT_ID:
    case AOS_ADX_INTERSTITIAL_UNIT_ID:
    case AOS_ADX_AB_INTERSTITIAL_UNIT_ID:
      return 'interstitial';

    default:
      return null;
  }
};

class AdList {
  constructor(store, unitIds, key) {
    this.store = store;
    this.unitIds = unitIds;

    this.key = key || uuid.v4();

    this.removers = [];
  }

  load = (storyId) => {
    const { adLoadStatus } = this.store.getState().common;

    this.unitIds.forEach((unitId) => {
      if (unitId === AD_TYPES.STORY_AD_FULL) {
        this.store.dispatch(fetchStoryAdFull(storyId));
        return;
      }

      const adType = window.Ad.getAdType(unitId);
      if (adLoadStatus[adType] !== AD_STATUSES.SUCCESS) {
        window.ci.web.loadAd(unitId);
      }
    });
  };

  getShowableAd = () => {
    const { adLoadStatus, storyAdFull } = this.store.getState().common;

    let showableUnitId = null;
    let defaultUnitId = null;
    this.unitIds.some((unitId) => {
      if (unitId === AD_TYPES.STORY_AD_FULL && storyAdFull.isLoaded) {
        if (storyAdFull.data.isDefaultAd) {
          defaultUnitId = unitId;
          return false;
        }
        showableUnitId = unitId;
        return true;
      }

      const adType = window.Ad.getAdType(unitId);
      if (adLoadStatus[adType] === AD_STATUSES.SUCCESS) {
        showableUnitId = unitId;
        return true;
      }

      return false;
    });

    const unitId = showableUnitId || defaultUnitId;

    return { unitId, adType: getAdType(unitId) };
  };

  reload() {
    this.load(this.unitIds);
  }

  view = (unitId, meta = {}) => {
    window.ci.web.viewAd(unitId, { ...meta, adListKey: this.key });
  };

  viewOnlyLoaded = (meta = {}) => {
    const { unitId } = this.getShowableAd();
    if (!unitId) {
      return;
    }

    this.view(unitId, meta);
  };

  reset = () => {
    this.unitIds = [];
  };

  on = (eventName, callback) => {
    const removeEventHandler = window.ci.on(eventName, (e) => {
      const { meta } = e.detail;
      if (meta) {
        if (this.key !== meta.adListKey) {
          return;
        }
      }

      callback(e);
    });

    this.removers.push(removeEventHandler);
  };

  removeEventHandlers = () => {
    this.removers.forEach((remover) => remover());
    this.removers = [];
  };
}

class AdManager {
  constructor(store) {
    this.store = store;

    const { platform, version } = this.store.getState().common;

    this.platform = platform;
    this.version = version;
  }

  getUnitId = (
    adType,
    { storyType = STORY_TYPES.STANDARD.type, mediationType }
  ) => {
    if (adType === AD_TYPES.STORY_AD_FULL) {
      return AD_TYPES.STORY_AD_FULL;
    }
    const isIOS = this.platform === PLATFORMS.IOS;

    const interstitialId =
      this.store.getState().common.abTest.adxAbUnitId ||
      (isIOS ? IOS_ADX_INTERSTITIAL_UNIT_ID : AOS_ADX_INTERSTITIAL_UNIT_ID);

    if (mediationType === AD_MEDIATION_TYPES.ADX && this.platform) {
      switch (adType) {
        case AD_TYPES.FBINTERSTITIAL:
        case AD_TYPES.INTERSTITIAL:
        case AD_TYPES.INTERSTITIAL_BACKFILL:
          if (
            isEqualAppVersion(this.platform, this.version, {
              ios: '2.20.16',
              android: '2.22.3',
            })
          ) {
            return isIOS
              ? IOS_ADX_AB_INTERSTITIAL_UNIT_ID
              : AOS_ADX_AB_INTERSTITIAL_UNIT_ID;
          }
          return interstitialId;

        case AD_TYPES.REWARD:
        case AD_TYPES.CHEER_REWARD:
          return isIOS ? IOS_ADX_REWARD_UNIT_ID : AOS_ADX_REWARD_UNIT_ID;

        default:
          return null;
      }
    }

    switch (adType) {
      case AD_TYPES.FBINTERSTITIAL:
      case AD_TYPES.INTERSTITIAL:
        if (storyType === STORY_TYPES.STANDARD.type) {
          return isIOS
            ? IOS_MOPUB_STANDARD_INTERSTITIAL_UNIT_ID
            : AOS_MOPUB_STANDARD_INTERSTITIAL_UNIT_ID;
        }

        return isIOS
          ? IOS_MOPUB_ORIGINAL_INTERSTITIAL_UNIT_ID
          : AOS_MOPUB_ORIGINAL_INTERSTITIAL_UNIT_ID;

      case AD_TYPES.INTERSTITIAL_BACKFILL:
        if (storyType === STORY_TYPES.STANDARD.type) {
          return isIOS
            ? IOS_MOPUB_STANDARD_INTERSTITIAL_BACKFILL_UNIT_ID
            : AOS_MOPUB_STANDARD_INTERSTITIAL_BACKFILL_UNIT_ID;
        }

        return isIOS
          ? IOS_MOPUB_ORIGINAL_INTERSTITIAL_BACKFILL_UNIT_ID
          : AOS_MOPUB_ORIGINAL_INTERSTITIAL_BACKFILL_UNIT_ID;

      case AD_TYPES.REWARD:
        return isIOS
          ? IOS_MOPUB_WAITFREE_REWARD_UNIT_ID
          : AOS_MOPUB_WAITFREE_REWARD_UNIT_ID;

      case AD_TYPES.CHEER_REWARD:
        return isIOS
          ? IOS_MOPUB_CHEER_REWARD_UNIT_ID
          : AOS_MOPUB_CHEER_REWARD_UNIT_ID;

      default:
        return null;
    }
  };

  getAdType = getAdType;
  getAppAdType = getAppAdType;

  make = (unitIds, key) => {
    return new AdList(this.store, unitIds, key);
  };
}

export default {
  AdManager,
};



// WEBPACK FOOTER //
// ./src/app/utils/ad.js